import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, FileText, Loader2, Upload } from "lucide-react";
import { api } from "@/lib/api";

/** One document the client was asked for, with its own upload button — so each file counts against the right item. */
export function DocItemRow({ token, idx, item, onDone }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post(`/apply/docs/${token}/upload`, fd, { params: { item: idx }, headers: { "Content-Type": "multipart/form-data" } });
      onDone(idx, r.data);
      toast.success(`${item.label} — received`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "That upload didn't go through — try again");
    } finally { setBusy(false); }
  };
  return (
    <li className={`flex items-center gap-3 rounded-xl border p-3 transition-colors ${item.done ? "border-emerald-200 bg-emerald-50/60" : "border-slate-200 bg-white"}`}
        data-testid={`docs-item-${idx}`}>
      {item.done ? <CheckCircle2 className="size-4 text-emerald-600 shrink-0" /> : <FileText className="size-4 text-slate-400 shrink-0" />}
      <div className="min-w-0 flex-1">
        <div className="text-[13.5px] font-semibold text-slate-900">{item.label}</div>
        <div className={`text-[12px] ${item.done ? "text-emerald-700 truncate" : item.note ? "text-amber-800" : "text-slate-500"}`} data-testid={`docs-item-state-${idx}`}>
          {item.done ? (item.files?.length ? `Got it · ${item.files.join(", ")}` : "Got it — thank you")
            : item.note ? `Still needed — ${item.note}` : item.how ? `Still needed — ${item.how}` : "Still needed"}
        </div>
      </div>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={`docs-item-upload-${idx}`}
              className={`inline-flex items-center gap-1.5 h-9 px-3.5 rounded-full text-[12.5px] font-semibold transition-colors disabled:opacity-60 ${item.done ? "border border-slate-200 text-slate-700 hover:border-slate-300" : "bg-[#0055FF] text-white hover:bg-[#0044CC]"}`}>
        {busy ? <Loader2 className="size-3.5 animate-spin" /> : <Upload className="size-3.5" />}
        {busy ? "Sending…" : item.done ? "Add another" : "Upload"}
      </button>
      <input ref={ref} type="file" className="hidden" accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.csv" onChange={pick}
             data-testid={`docs-item-input-${idx}`} />
    </li>
  );
}

export default DocItemRow;
